import * as Domain from "@/domain";
import { FunctionComponent, ReactElement } from "react";
import { NumericFormat } from "react-number-format";
import { IAmountProps } from "./types";

export const Amount: FunctionComponent<IAmountProps> = (
  props: IAmountProps
): ReactElement<IAmountProps> => {
  const {
    currency,
    decimalScale,
    decimalSeparator,
    value,
    renderText,
    ...restProps
  } = props;

  return (
    <NumericFormat
      decimalScale={decimalScale}
      decimalSeparator={decimalSeparator}
      displayType="text"
      suffix={` ${Domain.Currency.symbol(currency)}`}
      thousandSeparator="&nbsp;"
      value={value || 0}
      renderText={
        renderText || ((value) => <span {...restProps}>{value}</span>)
      }
    />
  );
};
